import {mapEmptyToUndefined, mapNullToUndefined} from '../utils/zod';
import {CreatePartnerSiteRequest} from './../api/generated/index.defs';
import {z} from 'zod';

export const partnerSiteSchema = z.object({
  sendEvaluationToActiveUser: mapNullToUndefined(z.boolean().optional()),
  inactive: mapNullToUndefined(z.boolean().optional()),
  sortOrder: mapNullToUndefined(z.number().optional()),
  timeDifference: mapNullToUndefined(z.string().optional()),
  arfNumber: z.string(),
  name: z.string(),
  signatureUrl: z.string(),
  signatoryName: z.string(),
  signatoryTitle: z.string(),
  logoUrl: z.string(),
  arfSealUrl: z.string(),
  address: z.string(),
  city: z.string(),
  state: z.string(),
  country: z.string(),
  zipCode: z.string(),
  // S/N Tracking Settings
  serialNumberTrackingEnabled: mapNullToUndefined(z.boolean().optional()),
  soldToValues: mapNullToUndefined(z.string().optional()),
  allowCosDateOverride: mapNullToUndefined(z.boolean().optional()),
  allowCosSelfSelection: mapNullToUndefined(z.boolean().optional()),
  trackingReportEmails: mapNullToUndefined(z.string().optional()),
  cosCutOffDaysOverride: mapEmptyToUndefined(z.number().optional()),
  uecocExpirationDaysOverride: mapEmptyToUndefined(z.number().optional()),
  reportFrequency: mapNullToUndefined(z.string().optional()),
}) satisfies z.ZodSchema<CreatePartnerSiteRequest>;

export type PartnerSiteSchema = z.infer<typeof partnerSiteSchema>;
